import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
// @ts-ignore
import moment from 'moment-timezone';
// @ts-ignore
import cx from 'classnames';
import { Typography, IconButton, Icon } from '@material-ui/core';
import { EeInput } from 'components/EeInput/EeInput';

export class StartCollectionDatePicker extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    format: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    labelStyle: PropTypes.object,
    pickerWrapperStyle: PropTypes.object,
    minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    shouldDisableDate: PropTypes.func,
    required: PropTypes.bool,
    disableFuture: PropTypes.bool,
  };

  static defaultProps = {
    selectedDate: null,
    disabled: false,
    label: null,
    format: 'DD MMM YYYY',
    onClose: () => {},
    onOpen: () => {},
    labelStyle: {},
    className: '',
    open: false,
    required: false,
    disableFuture: false,
  };

  constructor(props: any) {
    super(props);

    this.state = {
      open: false,
      isFocused: false,
      focusedDate: null,
    };
  }

  onChange = (value: any) => {
    // @ts-ignore
    const { onChange } = this.props;

    if (!value || !value.isValid()) return;
    const momentDate = value ? value.startOf('day') : null;
    onChange({
      date: momentDate ? momentDate.toDate() : null,
      momentDate,
    });
  };

  onFocus = () => {
    // @ts-ignore
    const { selectedDate } = this.props;
    this.setState(
      {
        isFocused: true,
        focusedDate:
          selectedDate === null
            ? ''
            : moment(selectedDate).format('YYYY-MM-DD'),
      },
      () =>
        window.setTimeout(() => {
          // @ts-ignore
          const input = this.datePickerContainer.querySelector('input');
          if (input) input.select();
        }, 10),
    );
  };

  onBlur = (e: any) => {
    // @ts-ignore
    const { selectedDate, onChange, minDate, required } = this.props;

    if (!e.target.value) {
      if (required) {
        onChange({
          date: new Date(selectedDate),
          momentDate: moment(selectedDate),
        });
      } else {
        onChange({
          date: null,
          momentDate: null,
        });
      }
    } else {
      const momentDate = moment(e.target.value);
      if (momentDate.isValid()) {
        if (minDate && momentDate.isBefore(minDate)) {
          onChange({
            date: new Date(selectedDate),
            momentDate: moment(selectedDate),
          });
        } else {
          onChange({
            date: momentDate.isValid()
              ? momentDate.startOf('day').toDate()
              : new Date(selectedDate),
            momentDate: momentDate.startOf('day'),
          });
        }
      }
    }
    this.setState({ isFocused: false });
  };

  backToToday = () => {
    // @ts-ignore
    const { onChange, format } = this.props;

    const momentDate = moment().startOf('day');
    onChange({
      date: momentDate.toDate(),
      momentDate,
      formattedDateString: momentDate.format(format),
    });
  };

  openCalendar = () => {
    this.setState({ open: true });
  };

  clearDate = () => {
    // @ts-ignore
    const { onChange } = this.props;
    // @ts-ignore
    const { isFocused } = this.state;

    if (isFocused) return this.setState({ focusedDate: '' });

    return onChange({
      date: null,
      momentDate: null,
      formattedDateString: '',
    });
  };

  render() {
    const {
      format,
      label,
      labelStyle,
      className,
      disabled,
      selectedDate,
      pickerWrapperStyle,
      minDate,
      shouldDisableDate = () => false,
      required,
      disableFuture,
    } = this.props as any;
    // @ts-ignore
    const { isFocused, focusedDate, open } = this.state;
    return (
      <div
        className={cx('d-flex align-items-center', className, {
          'is-disabled': disabled,
        })}
        ref={(r) => {
          // @ts-ignore
          this.datePickerContainer = r;
        }}
      >
        {label && (
          <Typography
            variant="subtitle1"
            className="ee-label"
            style={labelStyle}
          >
            {label}
          </Typography>
        )}
        <div
          className={cx('d-flex align-items-center', {
            'not-allowed': disabled,
          })}
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            // backgroundColor: 'transparent',
            borderRadius: 10,
            border: 'solid 1px #dcdcde',
            width: '100%',
            maxWidth: 328 /* todo(@vmyshko): move to global theme 💅 */,
            height: 42,
            position: 'relative',
            ...pickerWrapperStyle,
          }}
        >
          {isFocused ? (
            <EeInput
              type="date"
              value={focusedDate}
              min={moment(minDate).format('YYYY-MM-DD')}
              onChange={(e: any) =>
                this.setState({ focusedDate: e.target.value })
              }
              onBlur={this.onBlur}
              style={{ borderWidth: 0 }}
              required={required}
              inputClassName={cx('ee-input-date', { 'd-none': !isFocused })}
            />
          ) : (
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                value={selectedDate}
                minDate={minDate}
                onChange={this.onChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                disabled={disabled}
                autoOk
                maskChar="_"
                mask="__/__/____"
                format={format}
                shouldDisableDate={shouldDisableDate}
                inputProps={{
                  style: {
                    fontSize: '16px !important',
                  },
                }}
                InputProps={{
                  className: 'te-input lens-h6',
                  disableUnderline: true,
                  style: {
                    width: 173,
                    borderRadius: 9,
                  },
                }}
                InputAdornmentProps={{
                  hidden: true,
                }}
                open={open}
                onAccept={() => {
                  this.setState({ open: false });
                }}
                onClose={() => {
                  this.setState({ open: false });
                }}
                className="mr-auto"
                disableFuture={disableFuture}
              />
            </MuiPickersUtilsProvider>
          )}
          <div
            className="position-absolute"
            style={{ top: 4, right: 4, zIndex: 1, backgroundColor: '#fff' }}
          >
            <IconButton
              size="small"
              disabled={disabled}
              onClick={this.clearDate}
              style={
                !required && selectedDate
                  ? {}
                  : { opacity: 0, pointerEvents: 'none' }
              }
            >
              <Icon>clear</Icon>
            </IconButton>
            {/* 
          <IconButton
            size="small"
            disabled={disabled}
            onClick={this.backToToday}
          >
            <Icon>history</Icon>
          </IconButton> */}

            <IconButton
              size="small"
              disabled={disabled}
              onClick={this.openCalendar}
            >
              <Icon>today</Icon>
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
}
